module.exports = __webpack_public_path__ + "mybuild/static/img/logo-college-black.140b8add.png";